import list from './list';
import create from './create';
import update from './update';
import show from './show'
import del from './delete';
import reset from './reset-password';

export default {
  namespaced: true,
  modules: {
    list,
    create,
    update,
    show,
    del,
    reset,
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js